import React, { useState } from "react";
import "./application.scss";
import emailjs from '@emailjs/browser';
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";

const titles = ["Mr", "Mrs", "Miss", "Ms", "Dr"];
const yesNo = ["Yes", "No"];

const Application = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);

  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID2,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        () => {
          setPopupMessage('✅ Message sent successfully!');
          setIsSubmitting(false);
          e.target.reset();
        },
        () => {
          setPopupMessage('❌ Something went wrong. Please try again later.');
          setIsSubmitting(false);
        }
      );
    
    // Clears the form after sending the email
    // e.target.reset();
  };

  const closePopup = () => setPopupMessage(null);
  return (
    <>
    <Navbar />
    <div className="application-form">
      <h4 className="subtitle">Application Form</h4>
      <h1 className="title">
        Please complete the form below as <br /> much as possible.
      </h1>

      <form className="form-grid" onSubmit={sendEmail}>
        <select name="title" className="full">
          <option>Select Title</option>
          {titles.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>

        <input type="text" name="user_name" placeholder="Full Name" />
        <input type="email" name="user_email" placeholder="Email Address" />

        <input type="text" name="user_phone" placeholder="Phone Number" />
        <input type="text" name="user_address" placeholder="Address" />
        <input type="text" name="user_post_code" placeholder="Post Code" />
        <input type="text" name="user_dob" placeholder="Date of Birth" />

        <input type="text" name="user_country_of_birth" placeholder="Country of Birth" />
        <input type="text" name="user_ethnicity" placeholder="Ethnicity" />

        <input type="text" name="user_disabilities" placeholder="Disabilities" />
        <input type="text" name="user_religion_or_belief" placeholder="Religion or Belief" />

        <select name="valid_passport">
          <option>Do you have a Valid Passport?</option>
          {yesNo.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>

        <select name="dbs_check">
          <option>Do you have a Valid Enhanced DBS Check?</option>
          {yesNo.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>

        <select name="drive_vehicle" className="full">
          <option>Do you drive and have a vehicle?</option>
          {yesNo.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>

        <select name="training_cert" className="full">
          <option>
            Do you have a Valid Training Qualification Cert for care work?
          </option>
          {yesNo.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>

        <select name="employment_history" className="full">
          <option>Current Employment and 5 Year employment History</option>
          <option>Unemployed</option>
          <option>1 - 2 years</option>
          <option>3 - 4 years</option>
          <option>5+ years</option>
        </select>

        <textarea 
          name="additional_info"
          className="full" 
          rows="5" 
          placeholder="Additional Info" 
        />

        <div className="submit-wrap">
          <button type="submit" className="submit-btn">
            Submit Now
          </button>
        </div>
      </form>
    </div>
    <Footer />

    {popupMessage && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-message">
            <p>{popupMessage}</p>
            <button onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Application;
